export default __webpack_public_path__ + "static/media/경남.71dc959e.svg";